module.exports = __webpack_public_path__ + "img/icon349.3b562d5d.png";